<template>
  <div class="wrapper">
    <FORM ref="childForm" @formclick="formclick" :formData="formData"></FORM>
    <table-page ref="childTable" @checkbox="checkbox" @btnclick="bthClick" :pageData="pageData"></table-page>
    <UPDATE ref="childUpdate" @submit="submit" :updateData="updateData"></UPDATE>
  </div>
</template>

<script>
//table封装组件
import tablePage from '@/components/page/table.vue'
import FORM from '@/components/page/form.vue'
import URL from '@/views/cms/util/url'
import UPDATE from '@/components/page/update.vue'
import Qs from 'qs'
import DateUtil from '@/utils/IM/tradeDataUtil'

let newsTypeList = [], newsTypeArr = {}, langs = {}
let startList = { 0: '一星', 1: '二星', 2: '三星', 3: '四星', 4: '五星' }
let status ={0:"待發佈",1:"已發佈"}
let productList = {}
export default {
  name: 'list',
  components: {
    tablePage,
    FORM,
    UPDATE
  },
  created() {
    this.initCascader()
    this.initProductType()
    this.initLangs()
  },
  methods: {
    checkbox(row) {
      this.deleteIds = row.map(key => key.id).join(',')
    },
    dataChange(url, option, suc, fail) {
      this.$axios.post(url, Qs.stringify(option || {})).then(res => {
        if (suc && (typeof suc == 'function')) suc(res)
      }).catch(res => {
        if (fail && (typeof fail == 'function')) fail(res)
      })
    },
    /*表格按钮点击事件*/
    bthClick(clickName, row) {
      if (clickName == 'update') {
        row.typeIds = row.typeIds.split(',')
        row.attribute = row.attribute.split(',')
        this.$refs.childUpdate.open(row)
      } else if (clickName == 'delete') {
        this.dataChange(URL.article.del + '/' + row.id, { id: row.id }, res => {
          if (res.code == 0) {
            this.$refs.childTable.defaultGetData(this.queryData)
            this.$message.success('suc')
          } else {
            this.$message.error(res.message)
          }
        })
      }
    },
    /*查询表单按钮点击事件*/
    formclick(clickName, data) {
      if ('查询' == clickName) {
        this.queryData = data
        this.$refs.childTable.defaultQueryData(data)
      } else if ('新增' == clickName) {
        this.$refs.childUpdate.open()
      }
    },
    /*新增或跟提交数据触发事件*/
    submit(model) {
      model.typeIds = model.typeIds.join(',')
      model.attribute = model.attribute.join(',')
      //根据是否包含id更新还是添加
      this.dataChange((model.id != undefined && model.id != null && model.id != '') ? URL.article.edit : URL.article.edit, model, res => {
        if (res.code == 0) {
          this.$refs.childUpdate.close()
          this.$message.success('操作成功')
          this.$refs.childTable.defaultGetData(this.queryData)
        } else {

        }
      })
    },
    delNodes(nodes = []) {
      for (let item of nodes) {
        if (item.children.length <= 0) {
          delete item.children
        } else {
          this.delNodes(item.children)
        }
      }
      return nodes
    },
    addNodes(data) {
      for (let i in data) {
        newsTypeArr[data[i].value] = data[i].label
        if (data[i].children && data[i].children.length > 0) {
          this.addNodes(data[i].children)
        }
      }
      return newsTypeArr
    },
    initCascader() {
      this.$axios.post(URL.type.cascader, {}).then(res => {
        if (res.code == 0) {
          let data = JSON.parse(JSON.stringify(res.result))
          this.delNodes(data)
          newsTypeList = data
          this.formData.cols.find(function(e) {
            return e.field == 'typeIds'
          }).optionList = data
          this.updateData.cols.find(function(e) {
            return e.field == 'typeIds'
          }).optionList = data
          this.addNodes(data)
          this.$refs.childTable.defaultQueryData(this.queryData)
        }
      })
    },
    initProductType() {
      this.$axios.post(URL.product.typeList, {}).then(res => {
        if (res.code == 0) {
          let data = res.result
          if (data && data.length > 0) {
            for (const i in data) {
              productList[data[i].id] = data[i].name
            }
          }
        }
      })
    },
    initLangs() {
      this.$axios.post(URL.lang.query, {}).then(res => {
        if (res.code == 0) {
          let data = res.result
          if (data && data.length > 0) {
            for (const i in data) {
              langs[data[i].code] = data[i].displayName
            }
          }
        }
      })
    }
  },
  data() {
    return {
      deleteIds: '',
      queryData: {},
      /*新增或更新*/
      updateData: {
        cols: [
          { title: 'id', field: 'id', hidden: true },
          { title: '资讯类型', field: 'typeIds', type: 15, optionList: newsTypeList, required: true, data: [] },
          { title: 'lang', field: 'lang', type: 2, required: true, optionList: langs },
          { title: '资讯封面', field: 'imageUrl', upload: true },
          { title: '资讯详情第一张内容图', field: 'firstDetailImg', upload: true },
          { title: '资讯详情第二张内容图', field: 'secondDetailImg', upload: true },
          { title: '资讯详情第三张内容图', field: 'thirdDetailImg', upload: true },
          { title: '推荐星级', field: 'star', type: 2, optionList: startList, isNumber: true },
          { title: '来源', field: 'source', required: true },
          { title: '作者', field: 'author', required: true },
          { title: '标签', field: 'tag' },
          { title: '关联产品', field: 'attribute', type: 2, optionList: productList, multiple: true, data: [] },
          { title: '资讯标题', field: 'title', required: true },
          { title: '资讯详情', field: 'content', type: 14 }
        ]
      },
      /*from查询表单*/
      formData: {
        hasLable: true,
        cols: [
          { title: 'typeId', field: 'typeIds', type: 15, optionList: newsTypeList },
          { title: 'lang', field: 'lang', type: 2, optionList: langs },
          { title: 'title', field: 'title', textType: 'text' },
          { title: 'mine', field: 'mine', hidden: true },
          { click: '查询', auth: 'cms:article:list' },
          { click: '新增', auth: 'cms:article:save' }
        ]
      },
      /*table生成*/
      pageData: {
        queryUrl: URL.article.query,  //请求路径和参数
        selection: true,
        sequence: false,
        cols: [
          { title: 'title', field: 'title' },
          { title: 'companyCode', field: 'companyCode' },
          { title: 'typeIds', field: 'typeIds' , render: (data, full) => {
              let arr = data.split(','), newData = []
              for (const i in arr) {
                newData.push(newsTypeArr[arr[i]])
              }
              return newData.join('/')
            }
          },
          { title: 'tag', field: 'tag' },
          { title: 'star', field: 'star' },
          { title: 'attribute', field: 'attribute' , render: (data, full) => {
            return data;
             // let arr = data.split(','), newData = []
             // for (const i in arr) {
             //   newData.push(productList[arr[i]])
            //  }
             // return newData.join(',')
            }
          },
          { title: '浏览量', field: 'views' },
          { title: 'author', field: 'author' },
          { title: 'source', field: 'source' },
          { title: '源地址', field: 'sourceUrl' },
          { title: '状态', field: 'status' , render: (data, full) => {
              return status[data]
            }
          },
          {
            title: '发布时间', field: 'createTime', render: (data, full) => {
              return DateUtil.formatDate(data, 'yyyy-MM-dd hh:mm:ss')
            }
          },
          {
            title: '操作',
            btnClick: [{
              name: '删除',
              click: 'delete',
              type: 'primary',
              icon: 'el-icon-delete',
              auth: 'cms:article:del'
            }, { name: '修改', click: 'update', type: 'primary', icon: 'el-icon-edit', auth: 'cms:article:edit' }]
          }
        ]
      }
    }
  }
}
</script>
